export const summaryRows: string[] = [
  'Volume 01 — Cement Manufacturing: Raw Materials, Kiln, Clinker & Grinding',
  'Volume 02 — Cement Chemistry, Cement Types & Supplementary Cementitious Materials',
  'Volume 03 — Aggregates, Water, Admixtures & Concrete Mix Design',
  'Volume 04 — Concrete Production, Transport, Placing, Compaction & Curing',
  'Volume 05 — Concrete Testing: Fresh, Hardened, Laboratory & In-Situ',
  'Volume 06 — Durability, Defects, Concrete Pathology, Repair & Quality Control',
  'Bonus 1 — Concrete Mix Design & Calculations Quick-Reference',
  'Bonus 2 — Concrete Field Testing & Pour Inspection Checklists',
  'Bonus 3 — Concrete Cracks & Defects Identification Guide',
  "Bonus 4 — Cement Kiln & Clinker Quality Operator's Pocket Guide",
  'Bonus 5 — Cement & Concrete Terminology Dictionary',
  '7-day money-back guarantee',
  'Instant access',
];
